import styled from 'styled-components'

export const Columns = styled.div`
  display: flex;
`

export const Column = styled.div`
  width: 478px;
`
